import { format } from "../../core/helpers/string-util.js";
import { makeMonitorRepository } from "../../core/repositories/repositoryBuilders.js";
import { router } from "@foretagsplatsen/widgetjs";
import accountingDocument from "../shared/accountingDocument.js";
import ChartOfAccounts from "../../models/chartOfAccounts/ChartOfAccounts.js";
import session from "../../core/session.js";

/**
 * `importWizardDocument` is an abstract superclass for the actual import
 * documents (sie and e-conomic).
 *
 * It provides the common wizard as well as import state.
 *
 * @abstract
 */
export default accountingDocument.abstractSubclass((that, my) => {
	my.initialize = function () {
		my.super(...arguments);
		my.returnUrl = "";
		my.abortUrl = "";

		my.currentCompany = session.getCompany();

		my.chartOAccountsRepository = makeMonitorRepository({
			route: "/Shared/Company/#companyId/ChartOfAccounts",
			model: ChartOfAccounts,
			antiForgeryToken: session.getAntiForgeryToken(),
			defaultFilters: { companyId: my.currentCompany.getId() },
		});
	};

	my.initializeSubwidgets = function () {
		my.super(...arguments);
		my.importWidget = my.createImportWidget();
	};

	my.postInitialize = function () {
		my.super(...arguments);
		my.importWidget.onDone.register(my.whenDone);
		my.importWidget.onAbort.register(my.whenCancelled);
	};

	that.hasActionsMenu = function () {
		return false;
	};

	that.show = async function ({
		returnUrl,
		abortUrl,
		businessIdentityCode,
		isExistingLightCompany,
		economicToken,
		economicAgreementNumber,
	}) {
		my.returnUrl = decodeURIComponent(returnUrl);
		my.abortUrl = decodeURIComponent(abortUrl);

		businessIdentityCode &&= decodeURIComponent(businessIdentityCode);
		if (economicToken) {
			economicToken = decodeURIComponent(economicToken);
			my.importWidget.setEconomicToken(economicToken);
		}
		if (economicAgreementNumber) {
			economicAgreementNumber = decodeURIComponent(
				economicAgreementNumber,
			);

			my.importWidget.setBusinessIdentityCode(economicAgreementNumber);
		}
		isExistingLightCompany &&= decodeURIComponent(isExistingLightCompany);

		my.importWidget.setCompanyId(my.currentCompany.getLegacyId());

		// This is in case of Light agency, to be able to prevent mistaken creation of companies
		my.importWidget.setBusinessIdentityCode(businessIdentityCode);
		my.importWidget.setIsExistingLightCompany(isExistingLightCompany);
		my.importWidget.setCompany(my.currentCompany);

		const allChartsOfAccounts = await my.chartOAccountsRepository.get();

		my.importWidget.setChartsOfAccounts(
			allChartsOfAccounts.map((chartOfAccounts) => ({
				name: chartOfAccounts.getName(),
				chartOfAccountsId: chartOfAccounts.getId(),
			})),
		);

		my.startWizard();
	};

	that.renderContentOn = function (html) {
		html.render(my.titleWidget);

		html.div(
			{ id: "document" },
			html.div(
				{
					klass: "col-xs-12 col-sm-8 col-sm-offset-2 col-lg-6 col-lg-offset-3",
				},
				html.div(
					{ klass: "import-container clearfix" },
					my.renderDocumentContentOn,
				),
			),
		);
	};

	my.renderContentOn = function (html) {
		html.div({ klass: "import-wizard" }, my.importWidget);
	};

	my.getCurrentCompany = function () {};

	my.whenDone = function (importedCompany) {
		session.setCompany(importedCompany);
		const url = format(my.returnUrl, importedCompany.getLegacyId());
		my.redirectToLocationPath(url);
		// Make sure to reload the page, to update the fiscal years.
		router.getRouter().reloadPage();
	};

	my.whenCancelled = function () {
		my.redirectToLocationPath(my.abortUrl);
	};

	my.createImportWidget = function () {
		return my.subclassResponsibility();
	};

	my.startWizard = function () {
		that.update();
	};
});
